import { useQuery } from '@tanstack/react-query';
import { GET_PDF_EXTRACT_ALL, pdfFormsService } from '@/api';

export const usePdfExtractAll = (file: File | null, enabled = true) => {
	return useQuery({
		queryKey: [GET_PDF_EXTRACT_ALL, file?.name, file?.size, file?.lastModified],
		queryFn: () => pdfFormsService.extractAll(file as File),
		enabled: enabled && !!file,
		staleTime: Infinity,
		gcTime: 30 * 60 * 1000,
		retry: false,
	});
};
